import { Cargo } from './cargo';
import { TiposContratacoes } from './tipos-contratacoes';

export class ComposicaoRhProjeto {

    id: number;
    cargo: Cargo;
    tiposContratacoes: TiposContratacoes;
    qtd: number;
}